import { useMemo } from "react";
import "./index.css"

const Pagination = ({totalPages, currentPage, onSelectPage, visibleItems = 5}) => { 

  const pages = useMemo(() => {
    let startPage = currentPage - Math.floor(visibleItems / 2);
    let endPage = currentPage + Math.floor(visibleItems / 2);

    // Adjust for beginning of pages
    if (startPage < 1) {
      startPage = 1;
      endPage = Math.min(totalPages, startPage + visibleItems - 1);
    }

    // Adjust for end of pages
    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - visibleItems + 1);
    }

    const items = [];
    for (let i = startPage; i <= endPage; i++) {
      items.push(i);
    }

    if (!items.includes(totalPages)) {
      items.push(...(endPage < totalPages-1 ? ['...'] : []), totalPages)
    }

    return items;
  }, [totalPages, currentPage]);

  const selectPage = (e, page) => {
    e.preventDefault();

    if (page === 'prev') {
      page = (currentPage <= 1) ? 1 : currentPage - 1;
    }

    if (page === 'next') {
      page = (currentPage >= totalPages) ? totalPages : currentPage + 1;
    }

    onSelectPage(page);
  };
  
  return (
    <div className="pagination-component">
      <ul>
        <li  class={`nav prev ${currentPage === 1 ? 'disabled' : ''}`}><a href="" onClick={(e) => selectPage(e, 'prev')}><i class="fa fa-chevron-left" aria-hidden="true" /> Anterior</a></li>
        {pages.map(page => (
          <li class={`${page === currentPage ? 'current' : ''}`}><a href="" onClick={(e) => selectPage(e, page)}>{page}</a></li>
        ))}
        <li class={`nav next ${currentPage === totalPages ? 'disabled' : ''}`}><a href="" onClick={(e) => selectPage(e, 'next')}>Próximo <i class="fa fa-chevron-right" aria-hidden="true" /></a></li>
      </ul>
    </div>
  )
}

export default Pagination;